import { render } from "./StudentTrendingCardComponent.vue?vue&type=template&id=a1170346&ts=true"
import script from "./StudentTrendingCardComponent.vue?vue&type=script&lang=ts"
export * from "./StudentTrendingCardComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__